import { ComponentLookupSpec } from '@plasmicapp/loader-react';

/* Load components defined in Plasmic Studio */
export const PLASMIC_STUDIO_COMPONENTS: ComponentLookupSpec[] = [
  'P0',
  'BuyerFAQ',
  'RekaFAQ',
];

/* Type information for plasmic component props */
export type PlasmicStudioComponentProps = {
  // ExampleComponent: {
  //   count: string,
  //   tab: string,
  // },
};
